<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex flex-col gap-3 p-5 min-h-[250px]">
      <div class="flex justify-between items-center">
        <h1 class="text-lg font-bold leading-3">Editar motivo de atendimento</h1>

        <button class="w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/motivos-atendimento">
          X
        </button>
      </div>

      <form class="flex flex-col gap-5 flex-1" [formGroup]="formReason">
        <div class="w-full wrapper flex flex-col gap-4 md:flex-row">
          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Descrição: </label>
            <input type="text" class="form-input" placeholder="Descrição" formControlName="description" />
          </div>

          <div class="form-group" *isAllowed="[ERoleAdminString.Admin]">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Parceiro: </label>
            <ng-select
              notFoundText="Nenhum item encontrado"
              [searchable]="false"
              placeholder="Parceiro"
              formControlName="partnerId"
            >
              <ng-option *ngFor="let partner of partners" [value]="partner.id">
                {{ partner.name }}
              </ng-option>
            </ng-select>
          </div>

          <div class="form-group" *ngIf="podeEscolherEmpresa">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Empresas: </label>
            <ng-select
              notFoundText="Nenhum item encontrado"
              [items]="companies"
              placeholder="Empresas"
              formControlName="companyIds"
              bindLabel="name"
              bindValue="id"
              [multiple]="true"
            >
            </ng-select>
          </div>
        </div>
        <div class="form-group flex justify-end items-end">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'reason.edit']"
            alt="Salvar Motivo de Atendimento"
            (click)="editReason()"
            class="w-80 h-9 btn btn--secondary"
          >
            + Salvar Motivo de Atendimento
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
